import { translation } from "@/configurations/i18n"
import * as Dialog from "@radix-ui/react-dialog"
import { forwardRef, useImperativeHandle, useState } from "react"
import { useTranslation } from "react-i18next"
import { StyledDialog } from "./styles"

export type TConfirmationDialog = {
  open: VoidFunction
  close: VoidFunction
}

type TConfirmationDialogProps = {
  onConfirm?: VoidFunction
  onCancel?: VoidFunction
  message: string
}

export const ConfirmationDialog = forwardRef<
  TConfirmationDialog,
  TConfirmationDialogProps
>(({ onCancel, onConfirm, message }, ref) => {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()

  useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
    close: () => setOpen(false)
  }))

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <StyledDialog.Overlay />
        <StyledDialog.Content onPointerDownOutside={e => e.preventDefault()}>
          <StyledDialog.ContentBox>
            <p> {message}</p>
          </StyledDialog.ContentBox>
          <StyledDialog.ButtonBox>
            <StyledDialog.CancelButton onClick={onCancel}>
              {t(translation.mySession.cancelButton)}
            </StyledDialog.CancelButton>
            <StyledDialog.ConfirmButton variant="secondary" onClick={onConfirm}>
              {t(translation.mySession.deleteButton)}
            </StyledDialog.ConfirmButton>
          </StyledDialog.ButtonBox>
        </StyledDialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
})
